// src/shared/area-cover.js - THE "my area's stores" list for the admin screens (v136.9, the area hand-over).
//
// The server's scope (src/worker/scope.js resolveScopeStores) is an area manager's own area PLUS any area handed to
// them for today. The admin screens build their store pickers in the browser from AREA_STORE_MAP[currentAdmin.area],
// so before this they never offered the handed-over stores. Every such picker now asks this ONE helper.
//
// admin:   the signed-in account (currentAdmin). cover_area_ids is written by src/areaHandover after sign-in (from
//          GET /api/admin/area-handover, today's hand-overs TO this person) and again on every create or end.
// areaMap: AREA_STORE_MAP ({ areaId: [store names] }).
// Returns the store names, own area first, each once. [] when there is nothing (never "every store": a caller that
// wants Head Office's everything checks the role itself, as before). Pure, no globals: bundled into each screen.
export function coverAwareAreaStores(admin, areaMap) {
  if (!admin || !areaMap) return [];
  const ids = [admin.area].concat(Array.isArray(admin.cover_area_ids) ? admin.cover_area_ids : []);
  const out = [];
  ids.forEach((id) => {
    if (id == null || String(id).trim() === '') return;
    const list = areaMap[id] || areaMap[String(id)];
    (Array.isArray(list) ? list : []).forEach((s) => { if (s && out.indexOf(s) === -1) out.push(s); });
  });
  return out;
}
